const TopicDetailPage = () => (<div>Topic Detail Page</div>);
export default TopicDetailPage;